class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '#main-cart-items .js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '#main-cart-footer .js-contents',
      }

    ];
          /*自定义sticky cart刷新*/
     if (document.querySelector('#main-cart-footer #main-sticky-cart')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '#main-sticky-cart',
      });
    }
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
     if (document.querySelector('#main-cart-footer .pay-later')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.pay-later',
      });
    }
    if (document.querySelector('#main-cart-footer .cart-discounts')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.cart-discounts',
      });
    }
    
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);


/* 自定义更新购物车按钮,由addToCart改变*/



class UpdateCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler() {
    const newVariantId = this.dataset.variantId;
    const originalVariantId = this.dataset.originalVariantId; // 原始变体 ID
    const productQuantity = this.dataset.productQuantity;

    // 如果新变体和原变体相同，则不进行任何更新操作
    if (newVariantId === originalVariantId) {
      console.log('New variant is the same as the original variant. No update needed.');
      return;
    }
    
    if (newVariantId) {
        // 先添加新变体
        this.addVariantToCart(newVariantId, productQuantity)
            .then(() => {
                // 添加新变体后再移除原有变体
                if (originalVariantId) {
                    return this.removeVariantFromCart(originalVariantId);
                }
            })
            .then(() => {
                // 刷新页面以显示最新的购物车状态
                location.reload();
            })
            .catch((error) => {
                console.error('Error updating cart:', error);
            });
    }
}

addVariantToCart(variantId, quantity) {
    this.setAttribute('disabled', true);
    this.classList.add('loading');

    const body = JSON.stringify({
        id: variantId,
        quantity: quantity
    });

    return fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
            if (parsedState.status === 422) {
                document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                    detail: {
                        errorMessage: parsedState.description
                    }
                }));
            } else {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: parsedState
                    }
                }));
            }
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            this.classList.remove('loading');
            this.removeAttribute('disabled');
        });
}

  removeVariantFromCart(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status && parsedState.status === 422) {
          console.error('Error removing variant from cart:', parsedState.message);
        } else {
          console.log('Variant removed from cart:', parsedState);
        }
      });
  }
}

customElements.define('update-cart', UpdateCart);


/* upsell add on items */

if (!customElements.get('add-on-item-card')) {
  class AddonItemCard extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.variantId;  // 获取产品 ID
      this.checkbox = this.querySelector('.add-to-cart-checkbox');  // 获取复选框元素
    }

    connectedCallback() {
      // 页面加载时，恢复复选框状态
      this.restoreCheckboxStateFromCart();

      document.addEventListener('cart:updated', () => {
        this.restoreCheckboxStateFromCart();
      });

      // 如果是 Shopify 的设计模式，监听 section:load 事件
      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', () => {
          this.restoreCheckboxStateFromCart();  // 恢复复选框状态
        });
      }

      this.changeCart();
    }

    changeCart() {
      if (!this.checkbox) return;

      this.checkbox.addEventListener('change', () => {
        if (this.checkbox.checked) {
          console.log('这是 check 了的');
         this.addToCart(this.variantId);
       } else {
          console.log('这是取消 check 了的');
         this.removeFromCart(this.variantId);
        }
      });
}

    addToCart(variantId) {
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      })
        .then(response => response.json())
        .then(data => {
          console.log('Product added to cart:', data);
          // 直接刷新页面
          location.reload();
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        });
    }

    removeFromCart(variantId) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (!cart.items || cart.items.length === 0) return;

          const variantIdInt = parseInt(variantId, 10);
          const item = cart.items.find(item => item.variant_id === variantIdInt);
          if (!item) return;

          const cartItemElement = document.querySelector(`.cart-item[data-variant-id="${variantId}"]`);
          if (!cartItemElement) return;

          const removeElement = cartItemElement.querySelector('cart-remove-button[data-index]');
          if (!removeElement) return;

          const line = removeElement.dataset.index;

          if (!line) return;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              line: line,
              quantity: 0
            })
          })
            .then(response => response.json())
            .then(data => {
              console.log('Product removed from cart:', data);
              // 直接刷新页面
              location.reload();
            })
            .catch(error => {
              console.error('Error removing product from cart:', error);
            });
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }

    restoreCheckboxStateFromCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (!cart.items || cart.items.length === 0) return;

          const variantIdInt = parseInt(this.variantId, 10);
          const itemInCart = cart.items.some(item => item.variant_id === variantIdInt);

          if (this.checkbox) {
            this.checkbox.checked = itemInCart;
          }
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }
  }

  customElements.define('add-on-item-card', AddonItemCard);
}


/* 购物车可应用折扣提示 */
document.addEventListener('DOMContentLoaded', () => {
  let updateTimeout;

  const updateDiscountNotices = async () => {
    // 防抖：100ms 内只执行一次
    if (updateTimeout) clearTimeout(updateTimeout);
    updateTimeout = setTimeout(async () => {
      try {
        // 每次都重新查找，保证动态生成的元素也能找到
        const notices = document.querySelectorAll('.cart-discount-notice');
        if (!notices.length) return;

        const res = await fetch('/cart.js');
        if (!res.ok) throw new Error('Failed to fetch cart');
        const cart = await res.json();
        const total = cart.items_subtotal_price / 100;

        notices.forEach(notice => {
          const threshold = parseFloat(notice.dataset.threshold);
          const currency = notice.dataset.currency || '$';
          const remainingSpan = notice.querySelector('.remaining-amount');
          const remaining = threshold - total;
          const progress = notice.querySelector('.progress-notice');
          const success = notice.querySelector('.success-notice');

          if (remaining > 0) {
            remainingSpan.textContent = `${currency}${remaining.toFixed(2)}`;
            progress.style.display = 'block';
            success.style.display = 'none';
          } else {
            progress.style.display = 'none';
            success.style.display = 'block';
          }
        });
      } catch (err) {
        console.error('更新购物车折扣提示失败：', err);
      }
    }, 100); // 100ms 防抖
  };

  // 初始化加载
  updateDiscountNotices();

  // 购物车事件触发
  ['cart:updated', 'cartdrawer:opened'].forEach(evt => {
    document.addEventListener(evt, updateDiscountNotices);
  });
});









(function () {
  const discountContainerSelector = '.cart-discounts';
  const inputSelector = '.custom-discount-form input';
  const submitBtnSelector = '.submit-discount';
  const errorSelector = '.custom-discount-form p.error';

  let discountForm;
  let discountList = [];
  let errorElement;
  let isProcessing = false;

  // ==========================
  // 初始化引用
  // ==========================
  function initRefs() {
    discountForm = document.querySelector(discountContainerSelector);
    errorElement = document.querySelector(errorSelector);

    if (discountForm) {
      const rawList = discountForm.dataset.discountList || '';
      discountList = rawList
        .split(',')
        .map(code => code.trim().toLowerCase())
        .filter(Boolean);
    } else {
      discountList = [];
    }
  }

  // ==========================
  // 获取购物车数据
  // ==========================
  async function getCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return res.json();
  }

  // ==========================
  // 获取折扣码应用信息
  // ==========================
  async function getDiscountInfo(discountCode) {
    const data = await getCart();
    const lowerCode = (discountCode || '').toLowerCase();

    let applied = false;
    let allocatedAmount = 0;

    (data.cart_level_discount_applications || []).forEach(d => {
      if (d.type === 'discount_code' && (d.title || '').toLowerCase() === lowerCode) {
        applied = true;
        allocatedAmount += parseFloat(d.total_allocated_amount || 0);
      }
    });

    (data.items || []).forEach(item => {
      (item.line_level_discount_allocations || []).forEach(d => {
        const app = d.discount_application || {};
        if (app.type === 'discount_code' && (app.title || '').toLowerCase() === lowerCode) {
          applied = true;
          allocatedAmount += parseFloat(d.amount || 0);
        }
      });
    });

    allocatedAmount = Math.round((allocatedAmount + Number.EPSILON) * 100) / 100;
    return { applied, allocatedAmount };
  }

  // ==========================
  // 显示/隐藏错误提示
  // ==========================
  function showError(msg) {
    if (errorElement) {
      errorElement.style.display = 'block';
      errorElement.textContent = msg;
    } else {
      alert(msg);
    }
  }

  function hideError() {
    if (errorElement) {
      errorElement.style.display = 'none';
      errorElement.textContent = '';
    }
  }

  // ==========================
  // 提交折扣码
  // ==========================
  async function submitDiscount(discountCode) {
    if (isProcessing) return;
    isProcessing = true;

    try {
      discountCode = (discountCode || '').trim().toLowerCase();
      hideError();

      if (!discountCode) return showError('Please enter a valid discount code');

      // 已存在 data-discount-list
      if (discountList.includes(discountCode)) {
        return showError('This discount code has already been applied.');
      }

      // 尝试应用折扣码（不会自动跳转）
      await fetch(`/discount/${encodeURIComponent(discountCode)}`, {
        method: 'GET',
        redirect: 'manual',
      });

      const codeInfo = await getDiscountInfo(discountCode);

      // 折扣码无效
      if (!codeInfo.applied) {
        return showError('Enter a valid discount code.');
      }

      // 折扣码存在但条件不满足
      if (!isFinite(codeInfo.allocatedAmount) || codeInfo.allocatedAmount <= 0) {
        return showError('This discount code is valid but does not meet the conditions.');
      }

      // ✅ 成功应用折扣码，将其加入 data-discount-list
      discountList.push(discountCode);
      if (discountForm) {
        discountForm.dataset.discountList = discountList.join(',');
      }

      // 刷新页面显示折扣
      window.location.reload();
    } catch (err) {
      console.error('[submitDiscount error]', err);
      showError('Something went wrong. Please try again.');
    } finally {
      isProcessing = false;
    }
  }

  // ==========================
  // 绑定事件
  // ==========================
  function bindDiscountEvents() {
    initRefs();
    if (!discountForm) return;

    // 防止重复绑定
    document.querySelectorAll(submitBtnSelector).forEach(btn => {
      btn.replaceWith(btn.cloneNode(true));
    });

    const submitBtn = document.querySelector(submitBtnSelector);
    if (submitBtn) {
      submitBtn.addEventListener('click', e => {
        e.preventDefault();
        const code = document.querySelector(inputSelector)?.value || '';
        submitDiscount(code);
      });
    }
  }

  // ==========================
  // 初始化 + 动态绑定
  // ==========================
  document.addEventListener('DOMContentLoaded', bindDiscountEvents);
  document.addEventListener('cart:updated', bindDiscountEvents);
  document.addEventListener('shopify:section:load', bindDiscountEvents);

  if (typeof subscribe !== 'undefined' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, bindDiscountEvents);
  }
})();
